import styled from 'styled-components';

export const StyledLogoutModal = styled.div`
  width: ${({ theme }) => theme.assetModalWidth};
  z-index: 200;
  position: absolute;
  top: 100%;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  animation: popup-animation-translate 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0s 1 normal forwards, popup-animation-opacity 0.1s cubic-bezier(0.5, 0.35, 0, 1) 0s 1 normal forwards;
  background: ${({ theme }) => theme.background};
  transform: scale(var(--app-scale));
  transform-origin: 100% 0;
  --base-offset: ${({ theme }) => 'calc(calc(max(22vw, 333px) * var(--app-scale)) + ' + theme.frameOffset + ' )'};
  right: calc(var(--base-offset) - calc(150px * var(--app-scale)));

  .logout-modal {
    background: ${({ theme }) => theme.background};
  }

  .logout-modal-all {
    position: relative;
    padding-top: 2rem;
  }

  .logout-modal-content {
    padding: 1.5rem;
  }

  .logout-modal-info-holder {
    border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
  }

  .connect-wallet-button-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .logout-modal-account {
    width: 1.5rem;
  }
  .logout-modal-question-decorator {
    border-right: solid 2px ${({ theme }) => theme.borderDark};
    border-left: solid 2px ${({ theme }) => theme.borderDark};
    width: ${({ theme }) => 'calc(1.875rem - ' + theme.frameWidth + ')'};
    background: ${({ theme }) => theme.selection};
    height: ${({ theme }) => theme.frameWidth};
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    float: right;
    margin-left: ${({ theme }) => 'calc(20px - ' + theme.frameWidth + ')'};
    margin-right: 20px;
  }

  .logout-modal-opensea-button-holder {
    padding: 18px;
    padding-top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .logout-modal-opensea-button-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .logout-modal-title-holder {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    #margin-top: 2rem;
    margin-bottom: 1.25rem;
    height: 26px;
    gap: 2px;
  }

  .logout-modal-moonpay-holder {
    border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  }

  .logout-modal-moonpay {
    border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.backgroundDark};;
    background: ${({ theme }) => theme.backgroundDark};
  }

  .logout-modal-address {
    padding: 1rem;
    padding-bottom: 0.75rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    div {
      font-family: "NeueMachina";
      font-size: 1.25rem;
      font-weight: 800;
      color: white;
    }
  }

  .logout-modal-address-controls {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 1rem;
  }
  
  .logout-delete-button {
    cursor: pointer;
  }

  .logout-modal-wallet-list {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(60vh - 3 * 64px);
  }

  .logout-modal-divider-holder {
    padding-left: 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.375rem;
    align-items: center;
  }

  .logout-modal-divider-or {
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 2rem;
    font-weight: 500;
    color: white;
    line-height: 1;
  }

  .logout-modal-title-question {
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 2rem;
    font-weight: 500;
    color: ${({ theme }) => theme.selection};
    line-height: 1;
    padding-top: 0.375rem;
  }

  .logout-modal-divider {
    width: 100%;
    height: ${({ theme }) => theme.frameWidth};
    background: ${({ theme }) => theme.frame};
  }

  .logout-modal-title-stub-short {
    background: ${({ theme }) => theme.menuTitle};
    width: 20px;
    min-width: 20px;
    height: 100%;
  }

  .logout-modal-title-stub-long {
    background: ${({ theme }) => theme.menuTitle};
    width: 100%;
    height: 100%;
  }

  .logout-modal-title {
    text-transform: uppercase;
    height: 100%;
    padding: 0 6px;
    font-family: "BebasNeue";
    font-size: 2em;
    font-weight: 500;
    color: white;
    line-height: 1;
    white-space: nowrap;
  }

  .logout-modal-preview-content {
    width: 100%;
    height: ${({ theme }) => theme.assetModalPreviewHeight};
    position: relative;
    background: ${({ theme }) => theme.brightBlue};
  }

  .logout-modal-preview-content-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .logout-modal-preview-image-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .logout-modal-preview-image {
    max-width: 100%;
    height: 100%;
  }

  .logout-modal-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    width: 100%;
  }

  .logout-modal-info-description {
    width: 50%;
    padding: 12px 20px 0 20px;
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-weight: 400;
    font-size: 1.25rem;
  }

  .logout-modal-info-traits {
    width: 50%;
  }
  
  .logout-modal-title-button {
    height: 30px;
    padding: ${({ theme }) => theme.buttonFrameWidth};
    white-space: nowrap;
    position: relative;

    .logout-modal-title-button-corner {
      position: absolute;
      border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'transparent'};
      top: 0;
      bottom: 0;
      width: 8px
    }

    .logout-modal-title-button-corner-l {
      border-right: none;
      left: 0;
    }

    .logout-modal-title-button-corner-r {
      border-left: none;
      right: 0;
    }

    &:hover {
      .logout-modal-title-button-corner {
        border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'white'};
      }

      .logout-modal-title-button-corner-l {
        border-right: none;
      }

      .logout-modal-title-button-corner-r {
        border-left: none;
      }
    }
  }

  .logout-modal-title-button-content {
    width: 100%;
    height: 100%;
    padding: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
    align-items: center;
    transition: background linear 0.2s;
  }

  .logout-modal-title-button-label {
    font-family: 'BebasNeue';
    font-size: 1.25rem;
    font-weight: 700;
    color: black;
    padding-top: 4px;
  }
  .logout-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .logout-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .logout-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .logout-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .logout-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }
`;
